import styled from 'styled-components';
import { Paragraph } from '../Paragraph/Paragraph';
export var StyledComboboxEmptyState = /*#__PURE__*/styled(Paragraph).withConfig({
  displayName: "StyledComboboxEmptyState",
  componentId: "c11n-8-107-0__sc-lsfax2-0"
})([""]);